import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/lib/redux/store';

export const selectContactListsSlice = (state: RootState) => state.contactLists;

export const selectShouldRefreshList = createSelector(
  selectContactListsSlice,
  (substate) => substate.shouldRefreshList
);
